export const SHORTCUT_RACINE_AIDE = 'dossier_racine_aide_faq'
export const TYPE_FOLDER = 'folder'
export const TYPE_ARTICLE_FAQ = 'FAQ'
export const TYPE_ARTICLE_LINK = 'REDIRECTION'
